import React from 'react';
import { Fade } from '@material-ui/core';
import { PauseToggle } from '../PauseToggle';
import { PauseTypography } from '../PauseTypography';

type Props = {
  checked?: boolean,
  onToggleChanged?: (a: boolean) => any,
  title: string | React.ReactNode,
  description?: string | React.ReactNode,
  children?: any,
  disabled?: boolean,
}

export const PauseSpecialNotificationSetting = ({
  checked = false,
  onToggleChanged = () => null,
  title,
  description = '',
  children = null,
  disabled = false,
}: Props) => (
  <div
    css={(theme) => ({
      display: 'grid',
      gridAutoFlow: 'columns',
      gridTemplateColumns: `${theme.spacing(4)}px auto`,
      gridGap: theme.spacing(2),
    })}
  >
    <div>
      <PauseToggle
        disabled={disabled}
        checked={checked}
        onChange={(a) => onToggleChanged(a.target.checked)}
      />
    </div>
    <div>
      <div css={(theme) => ({
        paddingRight: theme.spacing(2),
        display: 'grid',
        gridAutoFlow: 'rows',
        gridGap: theme.spacing(1),
      })}
      >
        <PauseTypography variant="body1">
          {title}
        </PauseTypography>
        {description && (
        <PauseTypography
          variant="body2"
          color="pause.primary.medium"
        >
          {description}
        </PauseTypography>
        )}
        {checked && children && (
        <Fade in={checked} timeout={150}>
          <div css={(theme) => ({
            marginTop: checked ? theme.spacing(2) : 0,
          })}
          >
            {children}
          </div>
        </Fade>
        )}
      </div>
    </div>
  </div>
);
